<template>
  <div id="app" >
	  <screenfull :isContainer="true" />
	  <img class="fullscr-img" v-if="isFull" @click="toFullOrExit" src="@/assets/images/index/fullscreen-exit.png" alt="">
	  <img class="fullscr-img" v-if="!isFull" @click="toFullOrExit" src="@/assets/images/index/fullscreen.png" alt="">
	  <!-- <button @click="toFullOrExit">全屏</button> -->
    <router-view />
	
	
  </div>
</template>

<script>
	export default{
		data() {
			return{
				isFull: false
			}
		},
		methods:{
			    requestFullScreen () {
			      let de = document.documentElement
			      if (de.requestFullscreen) {
			        de.requestFullscreen()
			      } else if (de.mozRequestFullScreen) {
			        de.mozRequestFullScreen()
			      } else if (de.webkitRequestFullScreen) {
			        de.webkitRequestFullScreen()
			      }
			    },
			    exitFullscreen () {
			      let de = document
			      if (de.exitFullscreen) {
			        de.exitFullscreen()
			      } else if (de.mozCancelFullScreen) {
			        de.mozCancelFullScreen()
			      } else if (de.webkitCancelFullScreen) {
			        de.webkitCancelFullScreen()
			      }
			    },
			    toFullOrExit () {
					
			      this.isFull = !this.isFull
				  console.log(this.isFull)
			      if (this.isFull) {
			        this.fullImg = require('@/assets/images/exposition/maximize.png')
			        this.requestFullScreen()
			      } else {
			        this.fullImg = require('@/assets/images/exposition/minimize.png')
			        this.exitFullscreen()
			      }
			    }

		}
	}
</script>

<style lang="scss">
body {
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.fullscr-img{
	position: fixed;
	right: 10px;
	top: 5px;
	width: 15px;
	height: 15px;
	z-index: 100001;
}
</style>
